/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowBendDoubleUpRight(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M229.65723,109.65723l-48,48a8.00053,8.00053,0,0,1-11.31446-11.31446L212.68652,104,170.34277,61.65723a8.00053,8.00053,0,0,1,11.31446-11.31446l48,48A8.00122,8.00122,0,0,1,229.65723,109.65723Zm-48-11.31446-48-48A8.00066,8.00066,0,0,0,120,56V96.30469A104.13965,104.13965,0,0,0,24,200a8,8,0,0,0,16,0,88.11673,88.11673,0,0,1,80-87.63232V152a8.00053,8.00053,0,0,0,13.65723,5.65723l48-48A8.00122,8.00122,0,0,0,181.65723,98.34277Z" />
    </Svg>
  );
}

export default ArrowBendDoubleUpRight;
